import { render, staticRenderFns } from "./ContactsManagementModal.vue?vue&type=template&id=0e50efbe"
import script from "./ContactsManagementModal.vue?vue&type=script&lang=js"
export * from "./ContactsManagementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports